import jsPDF from "jspdf";
import arabicToThai from "../../../../hook/arabicToThai";
import oneBell from "../../../../assets/images/license/oneBell.png";
import oneJumbo from "../../../../assets/images/license/3.png";
import dayjs from "dayjs";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import "../../../../assets/font/THSarabunNew-normal";
import "../../../../assets/font/THSarabunNew-bold";

export async function createPdfRePrintAcc3(data = []) {
  const [convertToThaiNumerals, toThaiWord, numberToThaiText] = arabicToThai();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  console.log("data", data);

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "A4",
  });

  data?.forEach((person, index) => {
    if (index !== 0) pdf.addPage();

    let y = 20;
    pdf.setFont("THSarabunNew", "normal");
    pdf.setFontSize(16);

    // ส่วนหัว
    pdf.text(`กรุณาส่ง`, 25, y);
    y += 10;

    pdf.text(
      `${person.NAME}  (${person.CONTNO}) (${
        person.cusType === 0 ? "ผู้กู้" : "ผู้ค้ำประกัน " + person.cusType
      })`,
      40,
      y,
    );
    y += 5;
    pdf.text(person.address.ADDR ? person.address.ADDR : "-", 40, y);

    y += 5;
    pdf.text(
      `ต.${person.address.TUMB ? person.address.TUMB : "-"} อ.${
        person.address.AUMPDES ? person.address.AUMPDES : "-"
      } จ.${person.address.PROVDES ? person.address.PROVDES : "-"}`,
      40,
      y,
    );
    y += 5;
    pdf.text(person.address.ZIP, 40, y);

    y += 48;
    pdf.setFontSize(14);
    pdf.text(
      `วันที่ ${dayjs(person.DOCDT).add(543, "year").format("D MMMM YYYY")}`,
      150,
      y,
    );
    pdf.text(`เรื่อง   บอกเลิกสัญญากู้ยืม เลขที่ (${person.CONTNO})`, 20, y);
    y += 5;
    pdf.text(
      `เรียน   ${person.NAME} (${
        person.cusType === 0 ? "ผู้กู้" : "ผู้ค้ำประกัน " + person.cusType
      })`,
      20,
      y,
    );

    let xLeft = 30;
    let xRight = 120;
    let yGUARANTORS = y + 5;

    // เรียง GARNO จากน้อย -> มาก (0,1,2,...)  ถ้าไม่มีค่าให้ไปท้ายสุด
    const sortedGuarantors = [...(person?.guarantors ?? [])].sort((a, b) => {
      const ga = Number(a?.GARNO ?? Number.POSITIVE_INFINITY);
      const gb = Number(b?.GARNO ?? Number.POSITIVE_INFINITY);
      return ga - gb; // asc
    });

    sortedGuarantors.forEach((g, i) => {
      const x = i % 2 === 0 ? xLeft : xRight;

      pdf.text(
        `${g.SNAM} ${g.NAME1} ${g.NAME2} (${
          Number(g?.GARNO) === 0 ? "ผู้กู้" : `ผู้ค้ำประกัน ${Number(g?.GARNO)}`
        })`,
        x,
        yGUARANTORS,
      );

      // ครบ 2 คนในแถวแล้วค่อยขึ้นบรรทัดใหม่
      if (i % 2 === 1) yGUARANTORS += 5;
    });

    // หลังจากเขียนผู้ค้ำประกันทั้งหมด อัปเดต y ให้ตรงกับตำแหน่งปัจจุบัน
    y = yGUARANTORS + 15;
    const signDate = dayjs(person.SDATE)
      .add(543, "year")
      .format("DD MMMM YYYY");
    //   เนื้อหา
    const indent = "          "; // เว้นบรรทัดเริ่มต้นแบบย่อหน้า (ประมาณ 8 ช่องว่าง)
    y += 5;
    const content = [
      `${indent}ตามที่ท่าน ${person.SNAM} ${person.NAME1} ${
        person.NAME2
      } ทำสัญญากู้ยืมเงิน วันที่ ${signDate}  โดยได้นำรถยนต์ยี่ห้อ ${
        person?.TYPE ? person?.TYPE : "-"
      }  
รุ่น ${person?.BAAB ? person?.BAAB : "-"}  สี ${
        person?.COLOR ? person?.COLOR : "-"
      } ทะเบียน  ${person?.REGNO ? person?.REGNO : "-"}   ${
        person?.DORECV ? person?.DORECV : "-"
      } เลขเครื่อง  ${person?.ENGNO ? person?.ENGNO : "-"}  เลขตัวถัง   ${
        person?.STRNO ? person?.STRNO : "-"
      } เป็นหลักประกัน ในการกู้ยืมเงินทางธุรกิจ ไปจากผู้ให้กู้เป็นจำนวนเงินทั้งสิ้น ${currencyFormatPoint(
        person?.TOTPRC,
      )} บาท ${numberToThaiText(
        person?.TOTPRC,
      )}  โดยมีผู้ค้ำประกัน ได้ทำสัญญาค้ำประกัน หากผู้กู้ไม่ชำระยินยอมชำระแทนจนครบถ้วน`,

      `${indent}บัดนี้ปรากฏว่าผู้กู้ได้ค้างชำระค่างวด งวดที่ ${
        person?.EXP_FRM
      } - ${person?.EXP_TO} ซึ่งกำหนดชำระ  ${dayjs(person.DUEDATE)
        .add(543, "year")
        .format("D MMMM YYYY")} แล้วรวม ${
        person?.EXP_PRD
      } งวด เป็นจำนวนเงิน  ${currencyFormatPoint(
        person.EXP_AMT,
      )} บาท ${numberToThaiText(
        person.EXP_AMT,
      )} ผู้ให้กู้จึงขอให้ท่านนำเงินจำนวนดังกล่าวมาชำระให้เสร็จสิ้น ณ ที่ทำการผู้ให้กู้ ภายใน 30 วัน นับตั้งแต่วันที่ท่านได้รับหรือถือว่าได้รับหนังสือฉบับนี้`,

      `${indent}หากครบกำหนดดังกล่าวข้างต้น แล้วท่านเพิกเฉยไม่ดำเนินการตามหนังสือฉบับนี้ ผู้ให้กู้ขอถือว่าหนังสือฉบับนี้เป็นหนังสือบอก เลิกสัญญาดังกล่าวข้างต้น หากท่านประสงค์จะส่งมอบรถยนต์ที่เป็นหลักประกันเพื่อใช้หนี้ดังกล่าวข้างต้นขอให้ส่งมอบรถยนต์ที่ใช้เป็น หลักประกันในสภาพที่ใช้การได้ดี ภายใน 30 วัน นับตั้งแต่วันที่ครบกำหนดชำระหนี้ดังกล่าวข้างต้นหากท่านเพิกเฉยผู้ให้กู้มีความจำ เป็นต้องดำเนินคดีกับท่านทันที และท่านยังต้องรับผิดชอบในความเสียหายอันพึงเกิดขึ้นทั้งปวงด้วย`,

      `${indent}หากท่านมีการชำระเงินจำนวนดังกล่าวเป็นที่เรียบร้อยแล้วทางผู้ให้กู้ ต้องขออภัย ณ โอกาสนี้`,
    ];

    content.forEach((line) => {
      const splitText = pdf.splitTextToSize(line, 170);
      pdf.text(splitText, 20, y);
      y += splitText.length * 6;
    });

    pdf.text(`ขอแสดงความนับถือ`, 47, y + 2); // (x, y)
    let imageWidthImg = 25; // Adjust width to fit your needs
    let imageHeightImg = 15; // Adjust height to fit your needs
    pdf.addImage(
      oneJumbo,
      "PNG",
      50,
      y + 3,
      imageWidthImg - 3,
      imageHeightImg - 3,
    );

    //   pdf.text(
    //     `(${lawyerName ? lawyerName?.FNAME : "                        "}  ${
    //       lawyerName ? lawyerName?.LNAME : "                         "
    //     })`,
    //     lawyerId === 3 ? 40 : 45,
    //     y + 28
    //   ); // (x, y)
    pdf.text("(ร้อยตำรวจโทพงษ์ศรา วงษ์วีระขันธ์)", 40, y + 20); // (x, y)
    pdf.text("ทนายความประจำบริษัทฯ", 45, y + 24); // (x, y)
    pdf.text("ผู้รับมอบอำนาจ", 50, y + 29); // (x, y)
    pdf.text(`ขอแสดงความนับถือ`, 145, y + 2); // (x, y)
    pdf.addImage(oneBell, "PNG", 145, y + 3, imageWidthImg, imageHeightImg);

    pdf.text(`( จิราภรณ์  พวงทอง)`, 145, y + 20); // (x, y)
    pdf.text("เลขานุการแผนกเร่งรัด", 145, y + 24); // (x, y)
    pdf.text("ผู้ออกจดหมาย", 150, y + 29); // (x, y)
    pdf.setFont("THSarabunNew", "bold");
    pdf.text(
      `หมายเหตุ : ยอดที่แจ้งเป็นยอด ณ วันที่ ${dayjs(person.DOCDT)
        .add(543, "year")
        .format(
          "D MMMM YYYY",
        )} หากมาชำระหลังจากนี้อาจมีการเปลี่ยนแปลง ยอดที่แจ้งยังไม่รวมค่าใช้`,
      15,
      y + 40,
    );
    pdf.text(`จ่ายติดตามทวงถาม และเบี้ยปรับ`, 31, y + 45); // (x, y)
  });

  // เพิ่มหน้าใหม่
  pdf.addPage();

  // ตั้งค่าฟอนต์
  pdf.setFont("THSarabunNew", "normal");
  pdf.setFontSize(16);

  // config layout
  let finalYLeft = 20;
  let finalYRight = 20;
  let leftX = 10;
  let rightX = 115; // จุดเริ่มคอลัมน์ขวา
  let rowHeight = 30; // ความสูงต่อคน
  let count = 0;
  let columnCount = 0;

  data.forEach((person, index) => {
    const x = count % 2 === 0 ? leftX : rightX;
    let y = count % 2 === 0 ? finalYLeft : finalYRight;

    // --- ชื่อ + ประเภท ---
    const nameType = `${person.NAME} (${
      person.cusType === 0 ? "ผู้กู้" : "ผู้ค้ำประกัน " + person.cusType
    }) (${person.CONTNO})`;
    pdf.text(nameType, x, y);
    y += 6;

    // --- ที่อยู่ บรรทัด 1 ---
    if (person.address?.ADDR) {
      pdf.text(`เลขที่ ${person.address.ADDR}`, x, y);
      y += 6;
    }

    // --- ที่อยู่ บรรทัด 2 ---
    const addrLine2 = `ต.${person.address.TUMB} อ.${person.address.AUMPDES} จ.${person.address.PROVDES}`;
    pdf.text(addrLine2, x, y);
    y += 6;

    // --- ZIP ---
    pdf.text(person.address.ZIP || "", x, y);

    // --- อัปเดต Y ตามคอลัมน์ ---
    if (count % 2 === 0) {
      finalYLeft += rowHeight;
    } else {
      finalYRight += rowHeight;
      columnCount++;
    }

    count++;

    // --- ถ้าเกิน 9 แถวต่อคอลัมน์ (18 คน) ขึ้นหน้าใหม่ ---
    if (columnCount > 8) {
      columnCount = 0;
      console.log(" columnCount 0", columnCount);
      pdf.addPage();
      pdf.setFont("THSarabunNew", "normal");
      pdf.setFontSize(16);
      finalYLeft = 20;
      finalYRight = 20;
    }
  });

  const pdfBlob = pdf.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
}
